export interface LateralPrecisions {
  frontConductor: LateralDirection;
  precision: LateralPrecision;
}

export enum LateralPrecisionEnum {
  custodeGlass = 'custodeGlass',
  conductorGlass = 'conductorGlass',
  anotherGlass = 'anotherGlass',
  custodeFrontGlass = 'custodeFrontGlass',
  anotherCustode = 'anotherCustode',
  anyCustode = 'anyCustode',
  anyLateral = 'anyLateral',
  all = 'all',
}

export type LateralPrecision = `${LateralPrecisionEnum}`;

export enum LateralDirectionEnum {
  left = 'left',
  right = 'right',
}
export type LateralDirection = `${LateralDirectionEnum}`;
